import { VALIDATIONS, FIELD_TYPE } from '../config/const';
import _ from 'lodash';
import i18n from '../i18n';

let model;

function arrayIsEmpty(arrayData) {
  if (!_.isArray(arrayData)) return false;
  if (!arrayData.length) return true;

  const emptyValues = arrayData.filter(item => {
    return !item;
  });

  if (emptyValues.length) return true;

  return false;
}

function checkFieldLabel(field){
  return field.translate_label ? i18n.t(field.translate_label) : field.label;
}

function resolveErrorMessage(message, field) {
  message = message.translate_message ? message.translate_message : message.message;

  if (typeof message === 'function') return message();

  return message
}

function areGroupFieldsEmpty(fields) {
  let queriesEmpty = true;
  fields.map(field => {
    if (!_.isUndefined(model[field]) && model[field].trim() !== '') {
      queriesEmpty = false;
    }
  });
  return queriesEmpty;
}

function validateForm (form, options = {}) {
  model = form;
  const keys = Object.keys(model);
  let errors = [];

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const field = model[key];
    const value = field.value;

    const fieldErrors = validateField(field, value, options, true);
    errors = [...errors, ...fieldErrors];
  }

  return errors;
}

function validateField (field, value, options = {}, validatingForm = false) {
  if (!field.validate) return [];

  if (!validatingForm) {
    if (!model) model = {};
    model[field.name] = value;
  }

  const customValidators = options.customValidators || {};
  const localInputFields = options.localInputFields || [];
  const inputFields = options.inputFields || {};
  let errors = [], groupFailed;

  let fieldValid = true;
  field.validate.map(validation => {
    let invalid = false;
    switch (validation) {
      case 'custom':
        if (Object.keys(customValidators[field.name]).length) {

          Object.keys(customValidators[field.name]).forEach(name => {
            const validator = customValidators[field.name][name]
            if (validator && validator.validation && validator.validation(model || field)) {
              errors.push(resolveErrorMessage(validator, field))
              invalid = true;
            }
          })
        }
        break;
      case VALIDATIONS.REQUIRED:
        if (
          _.isUndefined(value) ||
          (_.isString(value) && value.trim() === '') ||
          value === null ||
          arrayIsEmpty(value)
        ) {
          errors.push(i18n.t('form.validation_messages.empty_field_error', [checkFieldLabel(field)]));
          invalid = true;
        }
        break;
      case VALIDATIONS.NUMBER:
        if (value == '') break
        if (!(((value - 0) == value) && ('' + value).trim().length > 0)) {
          errors.push(i18n.t('form.validation_messages.numerical_error', [field.label]));
          invalid = true;
        }
        break;

      case VALIDATIONS.CLEAN_STRING:
        /*eslint-disable */
        const specilCharactersRegex = /[!@#$%^=*(),.?"~:;{}[\]|<>\\\/]/i;
        /*eslint-enable */

        if (value && specilCharactersRegex.test(value)) {
          errors.push(i18n.t('form.validation_messages.clean_string_error', [checkFieldLabel(field)]));
          invalid = true;
        }
        break;

      case VALIDATIONS.NO_LEADING_OR_TRAILING_SPACES:
          if (typeof value === 'string' && (value.startsWith(" ") || value.endsWith(" ") )) {
            errors.push(i18n.t('form.validation_messages.leading_or_trailing_space_error', [checkFieldLabel(field)]));
            invalid = true;
          } else if (Array.isArray(value)) {
            value.forEach((v) => {
                if (v.startsWith(" ") || v.endsWith(" ") ) {
                  errors.push(i18n.t('form.validation_messages.leading_or_trailing_space_error', [checkFieldLabel(field)]));
                  invalid = true;
                }
            });
          }
          break;

      case VALIDATIONS.EMAIL_FORMAT:
        /*eslint-disable */
        const emailRegex = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
        /*eslint-enable */

        if (value && !emailRegex.test(value)) {
          errors.push(i18n.t('form.validation_messages.invalid_email_error', [checkFieldLabel(field)]));
          invalid = true;
        }
        break;
      case VALIDATIONS.URL_FORMAT:
        /*eslint-disable */
        const urlRegex = /^((https?):\/\/)?(((([^.:\/\s]+\.)+)?([^.:\/\s]{1,63})\.([^.:\/\s]{2,63})))+(\/(([^:\s]+))?)?$/i;
        /*eslint-enable */

        if (value && !urlRegex.test(value.trim())) {
          errors.push(i18n.t('form.validation_messages.invalid_url_error', [checkFieldLabel(field)]));
          invalid = true;
        }
        break;
      case VALIDATIONS.BRACKETS_MATCH:

        /*eslint-disable */
        if (value && (value.match(/\(/g) || []).length !== (value.match(/\)/g) || []).length) {
          errors.push(i18n.t('form.validation_messages.invalid_brackets_error', [checkFieldLabel(field)]));
          invalid = true;
        }
        /*eslint-enable */
        break;
      case VALIDATIONS.SEARCH_STRING:
        /*eslint-disable */
        const syntaxRegex = /^(?:|\()(?:|NOT )(?:\"[^,;\"]+\"\)*)(?:(?: AND NOT ?\(| OR NOT ?\(| AND ?\(?| OR ?\(?)(?:\"[^,;\"]+\"\)?))*(?:\)|")?$/i;
        /*eslint-enable */

        if (value && !syntaxRegex.test(value)) {
          errors.push(i18n.t('form.validation_messages.invalid_syntax_error', [checkFieldLabel(field)]));
          invalid = true;
        }
        break;
      case VALIDATIONS.UNIQUE:
        if (!field.unique || !field.unique.hasOwnProperty('values')) return console.warn(`Unique Validation on ${field.name} requires 'fieldsAdditions' prop with 'unique: {values: []}' defined.`)
        if (field.unique.values.find(v => v.trim().toLowerCase() === value.toLowerCase())) {
          errors.push(i18n.t('form.validation_messages.is_not_unique', [checkFieldLabel(field)]));
          invalid = true;
        }
        break;

      case VALIDATIONS.REQUIRE_ONE_OF:
        if (!field.group_fields || !field.group_fields.length > 0) return console.warn(`Require One Of Validation on ${field.name} requires 'fieldsAdditions' prop with 'group_fields: []' defined.`)
        if (areGroupFieldsEmpty(field.group_fields)) {
          invalid = true;
          groupFailed = field.group_fields;

          if (!field.validated) {
            errors.push(i18n.t('booleanSearch.query_validation.required'));

            field.group_fields.map(fieldKey => {
              let groupField = localInputFields.find(f => f.id === fieldKey || f.name === fieldKey);
              if (groupField) groupField.validated = true;
            });
          }
        }
        break;

      case VALIDATIONS.QUERYEDITOR_SYNTAX:
        if (field.type === FIELD_TYPE.QUERYEDITOR && field.syntaxValid === false) {
          invalid = true;
          errors.push(i18n.t('form.validation_messages.invalid_syntax_error', [checkFieldLabel(field)]));
        }
        break;

      case VALIDATIONS.QUERYEDITOR_ASIAN_SYNTAX:
        if (field.type === FIELD_TYPE.QUERYEDITOR) {
          // Validate that the following are wrapped in double quotes:
          // 1. Words in languages without whitespace separators (e.g., CJK - Chinese, Japanese, Korean)
          // 2. Words Containing Split Characters
          const quotedRe = /"(?:[^"\\]|\\.)*"/g;
          let masked = value.replace(quotedRe, m => " ".repeat(m.length));

          const allowedOpsRe = /\b(?:NEAR|BINEAR)\s*\/\s*\d+\b|\b(?:group|headline|content|provider_tags|case|contains|contains_case)\s*:|list_or\s*:\s*\{\{[\s\S]*?\}\}|~\s*\d+/giu;
          masked = masked.replace(allowedOpsRe, m => " ".repeat(m.length));

          // Requires ES2018+ and the `u` flag
          const violationReModern = /(?:[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}\p{Script=Thai}\p{Script=Lao}\p{Script=Khmer}\p{Script=Tibetan}\p{Script=Myanmar}\p{Script=Javanese}\p{Script=Balinese}]+|[^\s"]*[\\-\\u2013\\u2014_\\.@:/\\\\,;&#\\?!'"“”’][^\s"]*)/gu;
          // Works everywhere, even old JS engines
          const violationReFallback = /(?:[\u4E00-\u9FFF\u3400-\u4DBF\uF900-\uFAFF\u3040-\u309F\u30A0-\u30FF\uAC00-\uD7AF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u1780-\u17FF\u1B00-\u1B7F\uA980-\uA9DF]+|[^\s"]*[\\-\\u2013\\u2014_\\.@:/\\\\,;&#\\?!'"“”’][^\s"]*)/gu;
          
          if(violationReModern.exec(masked) !== null || violationReFallback.exec(masked) !== null) {
            invalid = true;
            errors.push(i18n.t('form.validation_messages.invalid_asian_syntax_error', [checkFieldLabel(field)]));
          }
        }
        break;

      case VALIDATIONS.BOOLEANSEARCH_SYNTAX:
        if (field.type === FIELD_TYPE.BOOLEANSEARCH && value && value.find(v => !v.value)) {
          invalid = true;
          errors.push(i18n.t('form.validation_messages.invalid_syntax_error', [checkFieldLabel(field)]));
        }
        break;

        case VALIDATIONS.STRING_MAX_LENGTH:
          if (value && value.length > field.limit) {
            invalid = true;
            errors.push(i18n.t('form.validation_messages.string_max_length_error', [checkFieldLabel(field), field.limit]));
          }
          break;
    }

    let validatedFields = [];
    if (groupFailed && validation === VALIDATIONS.REQUIRE_ONE_OF && (groupFailed.indexOf(field.id) !== -1 || groupFailed.indexOf(field.name) !== -1)) {
      field.group_fields.map(fieldKey => {
        if (inputFields[fieldKey]) validatedFields.push(inputFields[fieldKey]);
      });
      //if it had failed before and now it's valid reset groupFailed to false
      if (!invalid) groupFailed = false;
    }
    else {
      const validatedField = inputFields[field.id] || inputFields[field.name];
      if (validatedField) {
        validatedFields = [validatedField];
      }
    }

    if (invalid) {
      fieldValid = false;
      validatedFields.map(f => f.hasError = true);
    } else if (fieldValid) {
      validatedFields.map(f => f.hasError = false);
    }
  });

  return errors;
}

function delayFunction(callback, delayMs, context, loadingElement) {
  if(loadingElement || loadingElement === 0){
    context.loadingElement = loadingElement;
  }
  if (context.globalTimeout != null) clearTimeout(context.globalTimeout);
  context.globalTimeout = setTimeout(callback, delayMs);
}

export default {
  validateForm,
  validateField,
  delayFunction
}